import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faStar } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const CommunitySection = () => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth <= 768; // ვამოწმებთ არის თუ არა მობილური

  // იმიტირებული მონაცემები მომხმარებლებისთვის
  const users = [
    {
      id: 1,
      img: "/img/avatar1.svg",
      message: `${t("someone scanned")} 🥳`,
      width: "clamp(50px, 7vw, 100px)",
      height: "clamp(50px, 7vw, 100px)",
      top: "0",
      left: "0",
      transform: "rotate(-7deg)",
      background: "#d5afaf",
      bubbleStyle: {
        bottom: "-10px",
        right: "65px",
        transform: "rotate(0deg)",
        "--arrow-right": "-10px",
        "--arrow-bottom": "20px",
        "--arrow-rotation": "-25deg",
        "--arrow-border-width": "20px 10px 0",
      },
    },
    {
      id: 2,
      img: "/img/instagram.webp",
      message: null,
      width: "clamp(20px, 4vw, 50px)",
      height: "clamp(20px, 4vw, 50px)",
      top: "0",
      left: "160px",
      transform: "rotate(-2deg)",
      background: "white",
    },
    {
      id: 3,
      img: "/img/avatar2.svg",
      width: "clamp(40px, 5vw, 70px)",
      height: "clamp(40px, 5vw, 70px)",
      message: `${t("founded")}! 🎉`,
      top: "50px",
      right: "20px",
      transform: "rotate(4deg)",
      background: "#e3d8f9",
      bubbleStyle: {
        bottom: "50px",
        right: "55px",
        transform: "rotate(0deg)",
        "--arrow-right": "-15px",
        "--arrow-bottom": "-5px",
        "--arrow-rotation": "-45deg",
        "--arrow-border-width": "20px 10px 0",
      },
    },
    {
      id: 4,
      img: "/img/tiktok.webp",
      width: "clamp(30px, 7vw, 50px)",
      height: "clamp(30px, 7vw, 50px)",
      message: null,
      top: "185px",
      left: "25px",
    },
    {
      id: 5,
      img: "/img/avatar4.svg",
      message: `📍 ${t("i got the location")}`,
      width: "clamp(50px, 7vw, 130px)",
      height: "clamp(50px, 7vw, 130px)",
      top: "145px",
      left: "170px",
      transform: "rotate(-1deg)",
      background: "#d1e0ff",
      bubbleStyle: {
        bottom: "110px",
        right: "70px",
        transform: "rotate(-15deg)",
        "--arrow-right": "20px",
        "--arrow-bottom": "-15px",
        "--arrow-rotation": "-25deg",
        "--arrow-border-width": "20px 10px 0",
      },
    },
    {
      id: 6,
      img: "/img/avatar3.svg",
      message: null,
      width: "clamp(30px, 7vw, 60px)",
      height: "clamp(30px, 7vw, 60px)",
      top: "180px",
      right: "0",
      background: "#fde5db",
    },
    {
      id: 7,
      img: "/img/avatar5.svg",
      message: `${t("join us")} 🧡`,
      width: "clamp(40px, 7vw, 90px)",
      height: "clamp(40px, 7vw, 90px)",
      bottom: "15px",
      left: "0",
      transform: "rotate(9deg)",
      background: "#4ecdc5af",
      bubbleStyle: {
        fontSize: "0.7rem",
        bottom: "-15px",
        right: "10px",
        transform: "rotate(-3deg)",
        "--arrow-right": "40px",
        "--arrow-bottom": "25px",
        "--arrow-rotation": "90deg",
        "--arrow-border-width": "20px 10px 0",
      },
    },
    {
      id: 8,
      img: "/img/facebook.webp",
      message: null,
      width: "clamp(30px, 7vw, 60px)",
      height: "clamp(30px, 7vw, 60px)",
      bottom: "0",
      left: "190px",
    },
    {
      id: 9,
      img: "/img/avatar1.svg",
      message: `🔍🐾 ${t("i saw it on digomi")}!`,
      width: "clamp(20px, 7vw, 50px)",
      height: "clamp(20px, 7vw, 50px)",
      bottom: "45px",
      right: "60px",
      background: "#d1c7b6",
      bubbleStyle: {
        fontSize: "0.65rem",
        bottom: "60px",
        right: "-40px",
        transform: "rotate(-3deg)",
        "--arrow-right": "40px",
        "--arrow-bottom": "-15px",
        "--arrow-rotation": "5deg",
        "--arrow-border-width": "20px 10px 0",
      },
    },
  ];

  return (
    <div className="community-container-parent-container">
      <div className="community-container-inside-container">
        <div className="community-text-container">
          <h2>{t("community_title")}</h2>
          <p>{t("community_text")}</p>

          <a
            className="how-it-works-page-buy-now-button"
            href="https://www.facebook.com/profile.php?id=61579422506077"
            target="_blank"
          >
            {t("join us")}
          </a>
        </div>

        <div className="community-container">
          <FontAwesomeIcon
            className="heart yellow-heart"
            icon={faHeart}
            style={{
              top: isMobile ? "80px" : "120px",
              right: isMobile ? "90px" : "200px",
              animationDelay: "1.5s",
              // zIndex: "-1",
            }}
            size="2x"
          />
          <FontAwesomeIcon
            className="heart orange-heart"
            icon={faHeart}
            style={{
              top: isMobile ? "170px" : "260px",
              right: isMobile ? "210px" : "400px",
              animationDelay: "0s",
            }}
            size="2x"
          />
          <FontAwesomeIcon
            className="heart pink-heart"
            icon={faHeart}
            style={{
              top: isMobile ? "50px" : "100px",
              right: isMobile ? "230px" : "420px",
              animationDelay: "0.8s",
            }}
            size="2x"
          />
          {/* <FontAwesomeIcon
          className="heart"
          icon={faHeart}
          style={{ top: "50px", right: "320", animationDelay: "2.6s" }}
          size="2x"
        /> */}
          {/* <h2 className="section-title">შეუერთდი ჩვენს ქომიუნითის</h2> */}
          <div className="community-img-overlay"></div>
          <img
            src={t("pethub_community_image")}
            alt="Pethub community"
            className="pethub-community-image"
          />

          <div className="avatar-grid">
            {users.map((user) => (
              <div
                key={user.id}
                className="user-node"
                style={{
                  top: user.top,
                  left: user.left,
                  right: user.right,
                  bottom: user.bottom,
                  transform: user.transform,
                  background: user.background,
                }}
              >
                <img
                  src={user.img}
                  alt="User"
                  className="user-avatar"
                  style={{
                    width: user.width,
                    height: user.height,
                  }}
                />
                {user.message && (
                  <div className="speech-bubble" style={user.bubbleStyle}>
                    {user.message}
                  </div>
                )}

                {/* წერტილოვანი ხაზებისთვის შეგვიძლია გამოვიყენოთ ფონური SVG */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunitySection;
